
import React, { useState } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import styles from './styles.module.scss';
import EditableText from "@/components/EditableText";
import EditableImage from "@/components/EditableImage";
import clsx from "classnames";
import PropTypes from "prop-types";
import Link from "next/link"
import sourceflowEnums from "@/sourceflow.enums";
import Locations from "@/.sourceflow/locations.json";

export default function ConsultantCard2({
    className,
    pathPrefix,
    global,
    post,
}) {

    const matchedLocation = Locations?.category_values?.filter(category =>
        post.locations?.includes(category.id)
    );

    return (
        <Card className={clsx(className, styles.root)}>
            <img
                src={
                    post?.image?.url
                    ? post.image.url
                    : post?.image
                    ? post.image
                    : "/images/placeholders/img-placeholder.jpg"
                }
                size="x400"
                alt={post.title}
                className="mb-4"
                height="100%"
            />
            <div className='consultant-name mb-1'>{post.title}</div>
            {post.position && (
                <div className='consultant-position'>{post.position}</div>
            )}
            {post.state ? (
                <div className='mt-4 d-flex gap-2 justify-content-center'>
                    <span className='post-location'>
                    {post.state}
                    </span>
                </div>
                ) : (
                <>
                    {post.location && (
                    <div className='consultant-position'>{post.location}</div>
                    )}
                    {Array.isArray(post.locations) && post.locations.length > 0 && (
                        <div className='mt-4 d-flex gap-2 justify-content-center'>
                            {post.locations.map((category, index) => (
                                <span key={index} className='post-location'>
                                    {category}
                                </span>
                            ))}
                        </div>
                    )}
                </>
            )}
        </Card>
    )
}
ConsultantCard2.defaultProps = {
    pathPrefix: "",
    className: "",
};

ConsultantCard2.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};